/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);

const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement('script')
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
FormatMoney(value) {
  return accounting.formatMoney((value / 100), { symbol: "$",  format: "%s%v" })
},
  async AddItemsToCart (items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    });
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ComplementaryUpsells', () => ({
    main_product: null,
    selected_items: [],
    mounted() {
      let am = this;
      let $productInfo = am.$el.closest('.product__info-wrapper');
      let $form_atc = $productInfo.querySelector('.product-form form');
      let $btn_atc = $form_atc.querySelector('.product-form__submit');

      am.LoadProductJson();

      // on variant change
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        let variant = am.main_product.variants.find(v => v.id.indexOf(e.data.variant.id) !== -1);
        am.main_product.selected_variant = variant;
      });

      // on upsell selection
      document.addEventListener('toggle-upsell', (e) => {
        let product = e.detail.product;
        let selected = e.detail.selected;
        product.qty = e.detail.qty;

        let item_exists = am.selected_items.find(p => p.id == product.id);
        let existing_item_index = am.selected_items.findIndex(p => p.id == product.id);
        if (item_exists) {
          if (!selected) {
            // remove item
            am.selected_items.splice(existing_item_index, 1);
          }
          else {
            // update variant
            item_exists = e.detail.product;
          }
        }
        else {
          if (selected) {
            // add item
            am.selected_items.push(product);
          }
        }
      });

      am.$watch('selected_items', () => {
        am.UpdatePrices();
        $form_atc.disabled = am.selected_items.length !== 0;
      });
      am.$watch('main_product.qty', am.UpdatePrices.bind(am));

      // add to cart
      $btn_atc.addEventListener('click', async (e) => {
        if (am.selected_items.length) {
          let items_to_add = am.selected_items.map((item) => {
            return {
              id: item.selected_variant.id.replace('id_', ''),
              quantity: item.qty
            }
          });

          await UTILS.AddItemsToCart(items_to_add);
          $form_atc.disabled = false;
          $form_atc.dispatchEvent(new Event('submit', {bubbles: true}))
        }
      });
    },
    UpdatePrices() {
      let am = this;
      let all_items = [...[am.main_product], ...am.selected_items];
      let total = all_items.reduce((sum, item) => {
        let item_price = item.selected_variant.price;
        return sum + item.qty * item_price;
      }, 0);
      let total_compare = all_items.reduce((sum, item) => {
        let item_price = item.selected_variant.compare_price || item.selected_variant.price;
        return sum + item.qty * item_price;
      }, 0);

      let discount_percent = Math.ceil((((total_compare - total) / total_compare) * 100));

      // update price on page
      document.querySelectorAll('.product__info-wrapper .price-item--regular').forEach(($regular_price) => {
        $regular_price.innerText = UTILS.FormatMoney(total_compare);
      });

      document.querySelectorAll('.product__info-wrapper .price-item--sale').forEach(($regular_price) => {
        $regular_price.innerText = UTILS.FormatMoney(total);
      });

      document.querySelectorAll('.product__info-wrapper .price__badge-sale').forEach(($discount) => {
        $discount.innerText = `-${ discount_percent }% OFF`;
      });
    },
    LoadProductJson() {
      let am = this;
      UTILS.ConvertStringToJS(am.$el.querySelector('[data-main-product-json]').innerHTML);

      product.qty = 1;
      am.main_product = product;

      // on qty change
      let $qty = document.querySelector(`.product-form__input input[name=quantity]`);
      $qty.addEventListener('change', (e) => {
        am.main_product.qty = parseInt($qty.value);
        am.$el.querySelectorAll('.ComplementaryProduct').forEach(($item) => {
          let detail = {
            qty: $qty.value,
            variant: am.main_product.selected_variant
          }
          $item.dispatchEvent(new CustomEvent('main-qty-updated', {detail}))
        });
      });
    }
  }));

  Alpine.data('ComplementaryProduct', () => ({
    product: null,
    selected: false,
    selected_variant: null,
    qty: 1,
    mounted() {
      let am = this;
      am.LoadProductJson();

      am.$watch('selected', () => {
        let detail = { product: am.product, selected: am.selected, qty: am.qty };
        document.dispatchEvent(new CustomEvent('toggle-upsell', { detail }));

        // modal btn
        let $btn = document.querySelector(`.btn-add-upsell[data-id="${ am.product.id }"]`);
        if (!$btn) return;
        $btn.classList.toggle('selected', am.selected);
      });

      am.$watch('qty', () => {
        let detail = { product: am.product, selected: am.selected, qty: am.qty };
        document.dispatchEvent(new CustomEvent('toggle-upsell', { detail }));
      });

      am.$watch('selected_variant', () => {
        let detail = { product: am.product, selected: am.selected, qty: am.qty };
        document.dispatchEvent(new CustomEvent('toggle-upsell', { detail }));
      });

      // on variant change
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        let variant = e.data.variant;
        let is_twinPack = variant.options.indexOf('Twin Pack') !== -1;
        let qty = is_twinPack ? 2 : 1;
        am.SetQty(qty);
      });

      am.$el.addEventListener('main-qty-updated', (e) => {
        let variant = e.detail.variant;
        let main_qty = parseInt(e.detail.qty);
        let is_twinPack = variant.options.indexOf('Twin Pack') !== -1;
        let qty = main_qty * (is_twinPack ? 2 : 1);
        am.SetQty(qty);
      });

      // toggle selection from modal
      document.addEventListener('add-upsell', (e) => {
        let product_id = e.detail.id;
        let $btn = document.querySelector(`.btn-add-upsell[data-id="${ product_id }"]`);
        if (am.product.id !== product_id) return;
        am.selected = !am.selected;
        $btn.classList.toggle('selected', am.selected);
      });
    },
    LoadProductJson() {
      let am = this;
      UTILS.ConvertStringToJS(am.$el.querySelector('[data-product-json]').innerHTML);

      am.product = product;
      am.selected_variant = product.selected_variant;

      let $qty = am.$el.querySelector('.quantity__input');
      $qty.value = 1;
      $qty.addEventListener('change', (e) => {
        am.qty = parseInt($qty.value);
      });
    },
    GetPrice() {
      let am = this;
      return {
        price: am.product.selected_variant.price * am.qty,
        compare_price: am.product.selected_variant.compare_price * am.qty
      }
    },
    SetQty(qty) {
      let am = this;
      am.qty = qty;
      let $qty = am.$el.querySelector('.quantity__input');
      $qty.value = am.qty;
    },
    UpdateSelectedVariant(e) {
      let am = this;
      let variant_id = e.target.value;
      let variant = am.product.variants.find(v => v.id.indexOf(variant_id) !== -1);
      am.product.selected_variant = variant;
      am.selected_variant = variant;
    }
  }));
});